const SubscribeForm = () => {
  const formSectionOpener = document.querySelector(".subscribe-form-preview__btn");
  const subscribeFormPreview = document.querySelector(".subscribe-form-preview");
  const formSection = document.querySelector(".subscribe-form__section");
  const subscribeFormFooter = document.querySelector(".subscribe-form__footer");

  if (formSectionOpener) {
    formSectionOpener.addEventListener("click", () => {
      formSection.classList.add("visible");
      subscribeFormPreview.classList.add("hidden");
    })
  }

  if (subscribeFormFooter) {
    const text = subscribeFormFooter.querySelector(".subscribe-form__footer-text");
    const expandBtn = subscribeFormFooter.querySelector(".subscribe-form__footer-expand-btn");
    const hideBtn = subscribeFormFooter.querySelector(".subscribe-form__footer-hide-btn");

    if (expandBtn) {
      expandBtn.addEventListener("click", () => {
        subscribeFormFooter.classList.add("expanded");
        subscribeFormFooter.style.maxHeight = subscribeFormFooter.scrollHeight + "px";
      });
    }

    if (hideBtn) {
      hideBtn.addEventListener("click", () => {
        subscribeFormFooter.classList.remove("expanded");
        subscribeFormFooter.style.maxHeight = window.innerWidth > 767 ? "48px" : "60px";
      });
    }
  }
}

export default SubscribeForm;